import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "queue-list-item" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

import { computed, PropType } from "vue";
import { QueueModel } from "../models";
import { ListBulletIcon, ArrowRightIcon } from "tir-style-system/icons/outline";
import { TirPmButton, TirPmButtonVariantEnum } from "tir-components";
import { TirPmNotificationEventBus, TirPmNotificationModel } from "tir-pm-notification";
import TaskMoveRequestModel from "../../task-drawer/models/TaskMoveRequestModel";
import { AdapterService } from "../adapter-service";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'queue-list-item',
  props: {
  /**Данные об очереди */
  queue: { type: Object as PropType<QueueModel> },
  /**Перенос задачи */
  isTransferTask: { type: Boolean, default: false },
  /**Есть ли родительская задача */
  isParentalTask: { type: Boolean },
  /**Прикрепленные очереди */
  attachedQueues: { type: Boolean },
  /**Наличие  подзадач */
  isSubtasks: { type: Boolean },
  /**id задачи */
  taskId: { type: Number },
},
  emits: ["copy", "showSettingsTask", "transferTask"],
  setup(__props, { emit }) {

const props = __props;


/**События */


const adapter = new AdapterService();

/**Текст с количеством задач */
const countText = computed(() => `${props.queue.Count || 0} задач`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ListBulletIcon), {
      class: _normalizeClass(["bulletIcon", { 'queue-list-item_queue-no-configured': !__props.queue.IsQueueConfigured }])
    }, null, 8, ["class"]),
    _createElementVNode("span", {
      class: _normalizeClass(["queue-list-item_text", { 'queue-list-item_queue-no-configured': !__props.queue.IsQueueConfigured }]),
      textContent: _toDisplayString(__props.queue.Name)
    }, null, 10, _hoisted_2),
    _renderSlot(_ctx.$slots, "button"),
    _createElementVNode("span", {
      textContent: _toDisplayString(countText.value),
      class: _normalizeClass(["queue-list-item_count", { 'queue-list-item_queue-no-configured': !__props.queue.IsQueueConfigured }])
    }, null, 10, _hoisted_3)
  ]))
}
}

})